import { DELIVERY_RESTRICTION_CHOICE } from '@/constants/enum';
import { shopInfoSelector } from '@/redux/slice/shop.slice';
import { Banner, BlockStack, Button, Collapsible, InlineStack, Link, List } from '@shopify/polaris';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { StyledText } from '../../styled';
import BoldSmallText from '@/components/BoldSmallText';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/constants/path';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const DeliveryInforBanner = ({ isOpen, onClose }: Props) => {
  const [dismissed, setDismissed] = useState(isOpen);
  const shopInfo = useSelector(shopInfoSelector);
  const navigate = useNavigate();

  const DELIVERY_INFO_MAP = {
    [DELIVERY_RESTRICTION_CHOICE.NO_VALID]: {
      current: 'No validation',
      alternatives: ['Maximum distance radius', 'Postal code match'],
    },
    [DELIVERY_RESTRICTION_CHOICE.POSTAL_CODE_MATCH]: {
      current: 'Postal code match',
      alternatives: ['Maximum distance radius', 'No validation'],
    },
    [DELIVERY_RESTRICTION_CHOICE.CUSTOM]: {
      current: 'Maximum distance radius',
      alternatives: ['Postal code match', 'No validation'],
    },
  };

  const handleNavigate = () => navigate(PATH.SETTINGS__DELIVERY_VALIDATION);

  const handleRenderList = () => {
    const setting = DELIVERY_INFO_MAP[shopInfo.deliveryRestrictionType as keyof typeof DELIVERY_INFO_MAP];
    if (!setting) return null;

    return (
      <List type="bullet">
        <List.Item>
          Your current local delivery validation:{' '}
          <StyledText fontWeight={'500'} color="#005BD3" cursor="pointer" textDecoration="underline" onClick={handleNavigate}>
            {setting.current}
          </StyledText>
        </List.Item>
        <List.Item>
          You can set validation based on <BoldSmallText as="span">{setting.alternatives[0]}</BoldSmallText> or{' '}
          <BoldSmallText as="span">{setting.alternatives[1]}</BoldSmallText>.
        </List.Item>
      </List>
    );
  };

  return (
    <Collapsible id={'delivery-info-banner'} open={dismissed}>
      <Banner
        title="Local delivery validation"
        onDismiss={() => {
          onClose();
          setDismissed(false);
        }}
      >
        <BlockStack gap={'200'}>
          {handleRenderList()}
          <InlineStack>
            <Button onClick={handleNavigate}>Change validation</Button>
          </InlineStack>
        </BlockStack>
      </Banner>
    </Collapsible>
  );
};
